import { createSlice } from '@reduxjs/toolkit';
import { resetToInitialState } from '~/reducers/common-actions';

export const userGroupsForCurrentUserSlice = createSlice({
    name: 'userGroupsForCurrentUser',
    initialState: [],
    reducers: {
        setUserGroupsForCurrentUser: (state, action) => {
            return action.payload;
        }
    },
    extraReducers: (builder) => {
        builder.addCase(resetToInitialState, () => {
            return [];
        });
    }
});

export const { setUserGroupsForCurrentUser } =
    userGroupsForCurrentUserSlice.actions;

export const selectUserGroupsForCurrentUser = (state) =>
    state.userGroupsForCurrentUser;

export default userGroupsForCurrentUserSlice.reducer;
